exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Droid+Sans);", ""]);

// module
exports.push([module.id, ".loader {\r\n\tposition: fixed;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tz-index: 9999;\r\n\tbackground: url('http://www.downgraf.com/wp-content/uploads/2014/09/01-progress.gif?e44397') 50% 50% no-repeat rgb(249,249,249);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main